import styled from 'styled-components';
import { Radio } from 'antd';

export const SettingsOverlayMenu = styled.div`
  width: 13rem;
`;

export const RadioBtn = styled(Radio)`
  font-size: 0.875rem;
`;

export const PwaInstallWrapper = styled.div`
  padding: 0 1rem 0.75rem;
`;
